import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { HelmetProvider } from 'react-helmet-async'
import { registerSW } from 'virtual:pwa-register'
import './index.css'
import App from './App.tsx'

// Register service worker for offline functionality
const updateSW = registerSW({
  immediate: true,
  onNeedRefresh() {
    // New content available
    if (confirm('Nouvelle version disponible. Actualiser ?')) {
      updateSW(true)
    }
  },
  onOfflineReady() {
    console.log('Application prête pour une utilisation hors ligne')
  },
  onRegisteredSW(swUrl: string) {
    console.log('Service Worker enregistré:', swUrl)
  },
  onRegisterError(error: Error) {
    console.error('Erreur d\'enregistrement du Service Worker:', error)
  }
})

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <HelmetProvider>
      <App />
    </HelmetProvider>
  </StrictMode>,
)

